module.exports = __webpack_public_path__ + "img/ico-14.0438b195.svg";